$(function () {
  if (!customElements.get('subscribe-form')) {
    customElements.define(
      'subscribe-form',
      class subscribeForm extends HTMLElement {
        constructor() {
          super();
        }
        emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        connectedCallback() {
          this.init();
        }

        init() {
          const root = $(this);
          const $inputDom = root.find('.input_text');
          const $formDom = root.find('form');
          const $emailDom = root.find('.subscribe_button');
          const $inputContainer = $inputDom.parents('.input_text_container');
          this.emptyEmail();
          $inputDom.on('input', () => {
            this.emptyEmail();
          });
          $emailDom.on('click', async (event) => {
            event.preventDefault();
            const emailValue = $inputDom.val();
            if (emailValue) {
              if (this.emailRegexp.test(emailValue)) {
                await this.handleSubmit(emailValue, $(event.currentTarget));
              }
            } else {
              $inputContainer.attr('data-error', 'true');
            }
          });
        }
        emptyEmail() {
          const root = $(this);
          const $inputDom = root.find('.input_text');
          const $emailDom = root.find('.subscribe_button');
          if ($inputDom.val().length > 0) {
            $emailDom.attr('data-empty', 'false');
          } else {
            $emailDom.attr('data-empty', 'true');
          }
        }

        async subscribe(data, $button) {
          // 显示加载状态
          $button.find('.rotate_icon').removeClass('hidden').addClass('flex');
          $button.find('.loading-button-text').addClass('hidden').removeClass('flex');

          try {
            const url = `/shopify/user/point/subscribe`;
            const timestamp = getEncryptTimestamp();
            const headers = {
              nonce: litime_nonce,
              ticket: litime_ticket,
              timestamp,
            };
            const res = await window.litime.http.post(url, {
              data,
              headers,
            });
            if (res.code === 200) {
              // 订阅成功，显示成功弹窗
              const successPopup = document.querySelector('.subscribe-success-popup');
              if (successPopup) {
                successPopup.classList.remove('hidden');
              }
              return res.data;
            } else {
              // 订阅失败，确保成功弹窗保持隐藏
              const successPopup = document.querySelector('.subscribe-success-popup');
              if (successPopup) {
                successPopup.classList.add('hidden');
              }
              throw new Error(window.i18n.request_failed);
            }
          } catch (error) {
            // 处理异常情况，确保成功弹窗保持隐藏
            const successPopup = document.querySelector('.subscribe-success-popup');
            if (successPopup) {
              successPopup.classList.add('hidden');
            }
            throw error;
          } finally {
            // 恢复按钮状态
            $button.find('.rotate_icon').addClass('hidden').removeClass('flex');
            $button.find('.loading-button-text').removeClass('hidden').addClass('flex');
          }
        }

        async handleSubmit(email, $button) {
          try {
            await this.subscribe(
              {
                email,
              },
              $button
            );
          } catch (error) {
            console.error('订阅失败:', error);
          }
        }
      }
    );
  }
});
